import React from "react";
import styled from "styled-components";
import { ReactComponent as BackArrow } from "../../Assets/iconsv2/generic/backArrow.svg";

const ProgressDots = ({ step, total, onBack }) => (
  <TopRow>
    {onBack && <BackBtn onClick={onBack}><BackArrow width={22} height={22} /></BackBtn>}
    <Dots>
      {Array.from({ length: total }, (_, i) => (
        <Dot key={i} $active={step === i + 1} />
      ))}
    </Dots>
  </TopRow>
);

export default ProgressDots;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 28px;
`;

const BackBtn = styled.button`
  position: absolute;
  left: 0;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;

const Dots = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const Dot = styled.div`
  width: ${({ $active }) => ($active ? "20px" : "8px")};
  height: 8px;
  border-radius: 4px;
  background: ${({ $active, theme }) =>
    $active ? theme.menu.selectedTextColor : theme.sidebar.borderColor};
  transition: all 0.2s ease;
`;
